import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {Toggle} from "../../models/toggle.model";

interface ToggleResponse { data: Toggle; }

export interface FeatureService { (): angular.IPromise<Toggle[]>; }

/* @ngInject */
export function featureService(
  FEATURE_TOGGLE: Object,
  FEATURE_TOGGLES: string[],
  API_URL: ApiUrl,
  $http: angular.IHttpService,
  $q: angular.IQService) {
  return (): angular.IPromise<Toggle[]> => {
    const togglesRequests = [];
    const toggles = [];

    // @TODO get toggles states within one request, for now we have only one toggle
    FEATURE_TOGGLES.forEach(name => {
      togglesRequests.push(
        $http.get(`${API_URL.toggle.replace(/:name/, name)}`)
          .then((response: ToggleResponse) => {
            return response.data;
          })
          .then((toggle: Toggle) => {
            toggles.push(toggle);
            FEATURE_TOGGLE[toggle.name] = toggle.enabled;
          })
      );
    });

    return $q
      .all(togglesRequests)
      .then(() => {
        return toggles;
      });
  };
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/feature/feature.service.ts
 **/